module.exports = __webpack_public_path__ + "img/nonnhsfees.42ed69b7.svg";